function createSafeStorage(getStorage: () => Storage) {
  const memoryStore = new Map<string, string>();
  return {
    getItem: (key: string): string | null => {
      try {
        return getStorage().getItem(key);
      } catch {
        return memoryStore.get(key) ?? null;
      }
    },
    setItem: (key: string, value: string): void => {
      try {
        getStorage().setItem(key, value);
      } catch {
        memoryStore.set(key, value);
      }
    },
    removeItem: (key: string): void => {
      try {
        getStorage().removeItem(key);
      } catch {
        memoryStore.delete(key);
      }
    },
  };
}

export const safeStorage = createSafeStorage(() => window.localStorage);
export const safeSessionStorage = createSafeStorage(
  () => window.sessionStorage,
);
